<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Card Slider</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<ng-container *ngIf="isBrowser;else noJsContent">
  <div class="content content--modifier-height">
    <h2>Customized useCase options for Card Slider</h2>
    <div class="content__tools-wrap">
      <div class="content__row">
        <label for="useCase" class="content__row-label">Use Cases</label>
        <select [(ngModel)]="selectedUseCase" class="c-input-group__control" id="useCase">
          <ng-container *ngFor="let useCase of useCases">
            <option [value]="useCase">{{ useCase }}</option>
          </ng-container>
        </select>
      </div>
    </div>
  </div>
  <div class="content" *ngIf="selectedUseCase === 'Arrow buttons with hide mode'">
    <h3 id="carouselHeading"> Arrow buttons with hide mode</h3>
    <maced-card-slider cardSliderId='cardSliderId' [cardDataList]="isMobileView? mobileCardList:cardList" (cardClickEvent)="cardClickEvent($event, 'useCase1')">
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">{{data.topText}}</p>
              <div *ngIf="data.hasIcon" class="c-card__body-info-head-icon">
                <em role="img" [attr.aria-label]="data?.tooltipMessage" [attr.alt]="data?.tooltipMessage" class="u-icon icon-info-circle" #iconTooltipReference></em>
                <maced-tooltip [id]="'Tooltip'" [tooltipTargetReference]="iconTooltipReference"
                  [message]="data.tooltipMessage" *ngIf="data.tooltipMessage">
                </maced-tooltip>
              </div>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">{{data.UpgradDigit}} </p>
            <p class="c-card__body-footer-index">
              <span class="c-card__body-footer-index-data">{{data.downGradeDigit}}</span>
              <span class="c-card__body-footer-index-icon">
                <span class="u-icon icon-arrow-narrow-up"></span>
              </span>
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>
  <div class="content" *ngIf="selectedUseCase === 'Arrow buttons with disable mode'">
    <h3  id="carouselHeading"> Arrow buttons with disable mode</h3>
    <maced-card-slider cardSliderId='cardSliderId1' [cardDataList]="isMobileView? mobileCardList: cardList" [arrowsDisabledMode]="true" (cardClickEvent)="cardClickEvent($event, 'useCase2')">
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">{{data.topText}}</p>
              <div *ngIf="data.hasIcon" class="c-card__body-info-head-icon">
                <em role="img" [attr.aria-label]="data?.tooltipMessage" [attr.alt]="data?.tooltipMessage"  class="u-icon icon-info-circle" #iconTooltipReference></em>
                <maced-tooltip [id]="'Tooltip'" [tooltipTargetReference]="iconTooltipReference"
                  [message]="data.tooltipMessage" *ngIf="data.tooltipMessage">
                </maced-tooltip>
              </div>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">{{data.UpgradDigit}} </p>
            <p class="c-card__body-footer-index">
              <span class="c-card__body-footer-index-data">{{data.downGradeDigit}}</span>
              <span class="c-card__body-footer-index-icon">
                <span class="u-icon icon-arrow-narrow-up"></span>
              </span>
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>
  <div class="content" *ngIf="selectedUseCase === 'Card Slider with 3 cards'">
    <h3  id="carouselHeading"> Card Slider with 3 cards</h3>
    <maced-card-slider cardSliderId='cardSliderId1' [cardDataList]="cardList1" (cardClickEvent)="cardClickEvent($event, 'useCase3')">
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">{{data.topText}}</p>
              <div *ngIf="data.hasIcon" class="c-card__body-info-head-icon">
                <em role="img" [attr.aria-label]="data?.tooltipMessage" [attr.alt]="data?.tooltipMessage" class="u-icon icon-info-circle" #iconTooltipReference></em>
                <maced-tooltip [id]="'Tooltip'" [tooltipTargetReference]="iconTooltipReference"
                  [message]="data.tooltipMessage" *ngIf="data.tooltipMessage">
                </maced-tooltip>
              </div>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">{{data.UpgradDigit}} </p>
            <p class="c-card__body-footer-index">
              <span class="c-card__body-footer-index-data">{{data.downGradeDigit}}</span>
              <span class="c-card__body-footer-index-icon">
                <span class="u-icon icon-arrow-narrow-up"></span>
              </span>
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>
  <div class="content" *ngIf="selectedUseCase === 'Card Slider with 2 Fluid cards'">
    <h3  id="carouselHeading"> Card Slider with 2 Fluid cards</h3>
    <maced-card-slider cardSliderId='cardSliderId1' [cardDataList]="cardList2" (cardClickEvent)="cardClickEvent($event, 'useCase4')"
      [hasCarouselFluid]="true">
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">{{data.topText}}</p>
              <div *ngIf="data.hasIcon" class="c-card__body-info-head-icon">
                <em role="img" [attr.aria-label]="data?.tooltipMessage" [attr.alt]="data?.tooltipMessage" class="u-icon icon-info-circle" #iconTooltipReference></em>
                <maced-tooltip [id]="'Tooltip'" [tooltipTargetReference]="iconTooltipReference"
                  [message]="data.tooltipMessage" *ngIf="data.tooltipMessage">
                </maced-tooltip>
              </div>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">{{data.UpgradDigit}} </p>
            <p class="c-card__body-footer-index">
              <span class="c-card__body-footer-index-data">{{data.downGradeDigit}}</span>
              <span class="c-card__body-footer-index-icon">
                <span class="u-icon icon-arrow-narrow-up"></span>
              </span>
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>

  <div class="content" *ngIf="selectedUseCase === 'Card Slider with upper navigating buttons'">
    <h3  id="carouselHeading"> Card Slider with upper navigating buttons</h3>
    <maced-card-slider cardSliderId='cardSliderId4' [cardDataList]="cardList" (cardClickEvent)="cardClickEvent($event, 'useCase4')"
     [hasUpperButtons]="true" [hasScrollBar]="true" [hasCarouselHeader]="true" [hasUpperButtonForMobile]="true">
     <ng-container ngProjectAs="[cardHeader]">      
        <p class="c-carousel__head-info-heading">Macmillan experiences</p>
        <p class="c-carousel__head-info-label">Dynamic topical content to increase student motivation and engagement</p>
     </ng-container>
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-top">
            <figure class="c-card__body-top-canvas">
              <img class="c-card__body-top-canvas-image" src="../../assets/images/yx8h6prm3pfpcppq53wa.png" alt="" />
            </figure>
            <div class="c-card__body-top-external-link">
              <maced-button buttonId="externalButton" ariaLabel="External button" color="link" size="small" shape="square" buttonType="button" icon="icon-link-external" target="external" position=""></maced-button>
            </div>
          </div>
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">Video</p>
              <p class="c-card__body-info-head-time">21 Oct,2024 | 12 mins</p>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">
              Poems about FOOD! by Little Dazzy Donuts
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>

  <div class="content" *ngIf="selectedUseCase === 'Card Slider with single card'">
    <h3  id="carouselHeading"> Card Slider with single card</h3>
    <maced-card-slider cardSliderId='cardSliderId6' [cardDataList]="cardList5" (cardClickEvent)="cardClickEvent($event, 'useCase4')"
     [hasUpperButtons]="true" [hasScrollBar]="true" [hasCarouselHeader]="true">
     <ng-container ngProjectAs="[cardHeader]">      
        <p class="c-carousel__head-info-heading">Macmillan experiences</p>
        <p class="c-carousel__head-info-label">Dynamic topical content to increase student motivation and engagement</p>
     </ng-container>
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-top">
            <figure class="c-card__body-top-canvas">
              <img class="c-card__body-top-canvas-image" src="../../assets/images/yx8h6prm3pfpcppq53wa.png" alt="" />
            </figure>
            <div class="c-card__body-top-external-link">
              <maced-button buttonId="externalButton" color="link" size="small" shape="square" buttonType="button" icon="icon-link-external" target="external" position=""></maced-button>
            </div>
          </div>
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">Video</p>
              <p class="c-card__body-info-head-time">21 Oct,2024 | 12 mins</p>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">
              Poems about FOOD! by Little Dazzy Donuts
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>

   <div class="content" *ngIf="selectedUseCase === 'Card Slider with lower navigating buttons'">
    <h3  id="carouselHeading"> Card Slider with lower navigating buttons</h3>
    <maced-card-slider cardSliderId='cardSliderId4' [cardDataList]="cardList" (cardClickEvent)="cardClickEvent($event, 'useCase4')"
     [showBottomNavButtons]="true" [hasScrollBar]="true" [hasCarouselFooter]="true">
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-top">
            <figure class="c-card__body-top-canvas">
              <img class="c-card__body-top-canvas-image" src="../../assets/images/yx8h6prm3pfpcppq53wa.png" alt="" />
            </figure>
            <div class="c-card__body-top-external-link">
              <maced-button buttonId="externalButton" ariaLabel="External button" color="link" size="small" shape="square" buttonType="button" icon="icon-link-external" target="external" position=""></maced-button>
            </div>
          </div>
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">Video</p>
              <p class="c-card__body-info-head-time">21 Oct,2024 | 12 mins</p>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">
              Poems about FOOD! by Little Dazzy Donuts
            </p>
          </div>
        </maced-global-card>
      </ng-template>
      <ng-container ngProjectAs="[cardFooter]">      
        <p class="c-carousel__footer-info-heading">Macmillan experiences</p>
        <p class="c-carousel__footer-info-label">Dynamic topical content to increase student motivation and engagement</p>
     </ng-container>
    </maced-card-slider>
  </div>

  <div class="content content--gamification-cards" *ngIf="selectedUseCase === 'Card Slider with gradient colors'">
    <h3  id="carouselHeading"> Card Slider with gradient colors</h3>
    <maced-card-slider cardSliderId='cardSliderId5' [cardDataList]="cardList" [hideNavigationButtons]="true" (cardClickEvent)="cardClickEvent($event, 'useCase4')"
     [showBottomNavButtons]="true" [hasTabIndex]="false" [hasScrollBar]="true" [hasClickEvent]="false" [hasCarouselFooter]="false" carouselTitle = "goals" [hasCardGradient]="true">
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-top">
            <figure class="c-card__body-top-canvas">
              <img class="c-card__body-top-canvas-image" src="../../assets/images/stars-2-on.svg" alt="" />
            </figure>
          </div>
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">Good score 6 times to get</p>
            </div>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>

  <div class="content" *ngIf="selectedUseCase === 'Cards carousel'">
   <h3  id="carouselHeading"> Cards carousel with pagination</h3>
    <maced-card-slider cardSliderId='cardSliderId6' [cardDataList]="cardList" [hasUpperButtons]="true" [isInfinitecarousel]="true"
      [showPagination] = 'true' (cardClickEvent)="cardClickEvent($event, 'useCase4')" [hasUpperButtonForMobile]="true">
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">{{data.topText}}</p>
              <div *ngIf="data.hasIcon" class="c-card__body-info-head-icon">
                <em role="img" [attr.aria-label]="data?.tooltipMessage" [attr.alt]="data?.tooltipMessage"  class="u-icon icon-info-circle" #iconTooltipReference></em>
                <maced-tooltip [id]="'Tooltip'" [tooltipTargetReference]="iconTooltipReference"
                  [message]="data.tooltipMessage" *ngIf="data.tooltipMessage">
                </maced-tooltip>
              </div>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">{{data.cardId}} </p>
            <p class="c-card__body-footer-index">
              <span class="c-card__body-footer-index-data">{{data.downGradeDigit}}</span>
              <span class="c-card__body-footer-index-icon">
                <span class="u-icon icon-arrow-narrow-up"></span>
              </span>
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>
  
  <div class="content" *ngIf="selectedUseCase === 'Cards carousel with single card scroll'">
   <h3  id="carouselHeading"> Cards carousel with single card scroll</h3>
    <maced-card-slider cardSliderId='cardSliderId6' [cardDataList]="cardList" [hasUpperButtons]="true" [isInfinitecarousel]="true" [hasUpperButtonForMobile]="true"
      [showPagination] = 'true' [hasCarouselHeader]="true" [cardsToScroll] ="1" [hasOverLay]="false" [cardsWithFullWidth] = 'true' (cardClickEvent)="cardClickEvent($event, 'useCase4')">
         <ng-container ngProjectAs="[cardHeader]">      
        <p class="c-carousel__head-info-heading">Macmillan experiences</p>
        <p class="c-carousel__head-info-label">Dynamic topical content to increase student motivation and engagement</p>
     </ng-container>
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
        <div class="c-card__body-top">
            <figure class="c-card__body-top-canvas">
              <img class="c-card__body-top-canvas-image" [src]="data.img" alt="" />
            </figure>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">{{data.cardId}} </p>           
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>

    <div class="content" *ngIf="selectedUseCase === 'Cards carousel with fadeIn/fadeOut'">
   <h3  id="carouselHeading"> Cards carousel with fadeIn/fadeOut</h3>
    <maced-card-slider cardSliderId='cardSliderId6' [cardDataList]="cardList" [hasUpperButtonForMobile]="true" [hasUpperButtons]="true" [isInfinitecarousel]="true" 
      [showPagination] = 'true' [hasCarouselHeader]="true" [cardsToScroll] ="1" [hasOverLay]="false" [isfadeInFadeOut]="true" [cardsWithFullWidth] = 'true' (cardClickEvent)="cardClickEvent($event, 'useCase4')">
         <ng-container ngProjectAs="[cardHeader]">      
        <p class="c-carousel__head-info-heading">Macmillan experiences</p>
        <p class="c-carousel__head-info-label">Dynamic topical content to increase student motivation and engagement</p>
     </ng-container>
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
        <div class="c-card__body-top">
            <figure class="c-card__body-top-canvas">
              <img class="c-card__body-top-canvas-image" [src]="data.img" alt="" />
            </figure>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">{{data.cardId}} </p>           
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>
</ng-container>
<ng-template #noJsContent>
  <div class="content">
    <maced-card-slider cardSliderId='cardSliderId' [cardDataList]="cardList">
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">{{data.topText}}</p>
              <div *ngIf="data.hasIcon" class="c-card__body-info-head-icon">
                <em role="img" [attr.aria-label]="data?.tooltipMessage" [attr.alt]="data?.tooltipMessage"  class="u-icon icon-info-circle" #iconTooltipReference></em>
                <maced-tooltip [id]="'Tooltip'" [tooltipTargetReference]="iconTooltipReference"
                  [message]="data.tooltipMessage" *ngIf="data.tooltipMessage">
                </maced-tooltip>
              </div>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">{{data.UpgradDigit}} </p>
            <p class="c-card__body-footer-index">
              <span class="c-card__body-footer-index-data">{{data.downGradeDigit}}</span>
              <span class="c-card__body-footer-index-icon">
                <span class="u-icon icon-arrow-narrow-up"></span>
              </span>
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>
  <div class="content">
    <h3  id="carouselHeading"> Card Slider with upper navigating buttons</h3>
    <maced-card-slider cardSliderId='cardSliderId4' [cardDataList]="cardList" (cardClickEvent)="cardClickEvent($event, 'useCase4')"
     [hasUpperButtons]="true" [hasScrollBar]="true" [hasCarouselHeader]="true">
     <ng-container ngProjectAs="[cardHeader]">
        <p class="c-carousel__head-info-heading">Macmillan experiences</p>
        <p class="c-carousel__head-info-label">Dynamic topical content to increase student motivation and engagement</p>
     </ng-container>
      <ng-template let-data let-inx='inx' #cardBody>
        <maced-global-card [cardId]="data.cardId" [cardName]="data.name">
          <div class="c-card__body-top">
            <figure class="c-card__body-top-canvas">
              <img class="c-card__body-top-canvas-image" src="../../assets/images/yx8h6prm3pfpcppq53wa.png" alt="" />
            </figure>
            <div class="c-card__body-top-external-link">
              <maced-button buttonId="externalButton" ariaLabel="externalButton" color="link" size="small" shape="square" buttonType="button" icon="icon-link-external" target="external" position=""></maced-button>
            </div>
          </div>
          <div class="c-card__body-info">
            <div class="c-card__body-info-head">
              <p class="c-card__body-info-head-title">Video</p>
              <p class="c-card__body-info-head-time">21 Oct,2024 | 12 mins</p>
            </div>
          </div>
          <div class="c-card__body-footer">
            <p class="c-card__body-footer-data">
              Poems about FOOD! by Little Dazzy Donuts
            </p>
          </div>
        </maced-global-card>
      </ng-template>
    </maced-card-slider>
  </div>
</ng-template>